/* tslint:disable */
const TRANSLATIONS: any = {
  "i18n.actionBar.cropImage": "Modifica",
  "i18n.actionBar.removeImage": "Elimina",
  "i18n.actionBar.swapImage": "Cambia",
  "i18n.additionalInfoItemLayers.smartSorted.new": "NOVITÀ!",
  "i18n.additionalProducts.addToCart": "Aggiungi all’ordine",
  "i18n.additionalProducts.frame.description": "Cornice in alluminio di alta qualità: argento opaco, vetro premium, non richiede colla",
  "i18n.additionalProducts.frame.emotionalHook": "♥️ Consiglio:",
  "i18n.additionalProducts.frame.subtitle": "Il puzzle completato è un bellissimo ricordo: con la nostra <b>cornice</b> sarà valorizzato alla perfezione.",
  "i18n.additionalProducts.frame2023.description": "Cornice in fibra di legno di alta qualità, facile da montare, senza vetro, inclusa la colla per puzzle",
  "i18n.additionalProducts.framePlastic.description": "Cornice in alluminio di alta qualità: argento opaco, vetro sintetico con rivestimento antiriflesso, non richiede colla",
  "i18n.additionalProducts.glue.description": "Per un massimo di due puzzle da 1000 pezzi, inclusa spugna applicatrice.",
  "i18n.additionalProducts.glue.hook": "Dai nuova vita al tuo puzzle trasformandolo in un quadro.\nIncolla e protegge in modo permanente.",
  "i18n.additionalProducts.roll.description": "Per puzzle da 48 a 2000 pezzi.",
  "i18n.additionalProducts.roll.hook": "Nessun tavolo libero? Nessun problema.\nArrotola il puzzle, mettilo da parte e continua più tardi.",
  "i18n.adventCalendarOverlay.activate": "Mostra l’anteprima delle 24 finestrelle",
  "i18n.adventCalendarOverlay.deactivate": "Nascondi l’anteprima delle 24 finestrelle",
  "i18n.adventCalendarOverlay.notice": "(I numeri e le linee visibili nell’anteprima non verranno stampati)",
  "i18n.button.addToCart": "Aggiungi al carrello",
  "i18n.button.apply": "Applica",
  "i18n.button.back": "Indietro",
  "i18n.button.cancel": "Elimina",
  "i18n.button.cancelAndFix": "cambia adesso",
  "i18n.button.chooseSmartSorted": "con SMART SORTED",
  "i18n.button.close": "Chiudi",
  "i18n.button.continue": "Continua",
  "i18n.button.createNewTextPlaceholders": "Inserisci il testo ",
  "i18n.button.ignore": "Ignora",
  "i18n.button.ignoreAndContinue": "continua comunque",
  "i18n.button.mobile.createNewTextPlaceholders": "Il testo",
  "i18n.button.noChanges": "senza SMART SORTED",
  "i18n.button.ok": "OK",
  "i18n.button.photos": "Foto",
  "i18n.button.retry": "Riprova",
  "i18n.button.uploadPhotos": "Carica foto",
  "i18n.button.withSmartSorted": "Con SMART SORTED",
  "i18n.button.withoutSmartSorted": "Senza SMART SORTED",
  "i18n.control.colorChooser.color": "Colore",
  "i18n.control.fontChooser.placeholderText": "Carattere",
  "i18n.control.imageQuality.checkImages": "Verifica risoluzione foto",
  "i18n.control.imageQuality.imageSuitability": "Qualità delle foto:",
  "i18n.control.imageQuality.indicatorAltText": "Qualità delle foto ",
  "i18n.control.imageZoom.zoom": "Zoom:",
  "i18n.control.templateChooser.title": "Scegli layout",
  "i18n.control.textEditing.rejectMessage.characterWontFit": "Per una migliore leggibilità, per favore inserire una linea di testo più corta.",
  "i18n.control.textEditing.rejectMessage.fontFamilyTooLarge": "Il carattere scelto è troppo grande per questo testo.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooLarge": "E’ stato raggiunta la massima grandezza di carattere per questo testo.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooSmall": "E’ stata raggiunta la grandezza minima di carattere per questo testo.",
  "i18n.control.textEditing.rejectMessage.insertLineBreak": "Inserisci l’interruzione di riga",
  "i18n.control.textEditing.rejectMessage.insertLineBreakOrResizeTextField": "Continua a scrivere su una seconda riga o di ingrandire il campo riservato al testo.",
  "i18n.control.textEditing.rejectMessage.invalidCharacters": "Per favore controlla il tuo testo, questo font non supporta tutti i caratteri.",
  "i18n.control.textEditing.rejectMessage.maxCharactersReached": "Il numero massimo di caratteri è stato raggiunto",
  "i18n.control.textEditing.rejectMessage.maxLinesReached": "Per una migliore leggibilità, per favore inserisci una linea di testo più corta.",
  "i18n.control.textEditing.rejectMessage.resizeTextField": "Ingrandisci il campo riservato al testo",
  "i18n.dialog.deletePlaceholder.message": "Questo passaggio non può essere annullato ",
  "i18n.dialog.deletePlaceholder.title": "Vuoi realmente eliminare questo segnaposto?",
  "i18n.dialog.error.title": [
    "Si è verificato un errore",
    "Si sono verificati degli errori"
  ],
  "i18n.dialog.insufficientImageQuality.message": "La risoluzione di questa immagine è troppo bassa per una stampa ottimale della foto!",
  "i18n.dialog.smartSorted.message": "Con SMART SORTED è possibile comporre la propria immagine da 1000 pezzi in modo innovativo e senza sforzo, anche senza il motivo di riferimento.",
  "i18n.dialog.smartSorted.title": "Fai un puzzle con successo garantito",
  "i18n.dialog.unchangedPlaceholders.boxTitle.message": "Clicca su \"{{text}}\", per cambiare il titolo della scatola.",
  "i18n.dialog.unchangedPlaceholders.boxTitle.title": "il titolo della scatola non è stato cambiato",
  "i18n.dialog.unchangedPlaceholders.buttons.clear.label": "Continua senza il titolo della scatola",
  "i18n.dialog.unchangedPlaceholders.image.message": [
    "Inserisci una foto cliccando sul segnaposto",
    "Inserisci le foto cliccando sui segnaposto"
  ],
  "i18n.dialog.unchangedPlaceholders.image.title": [
    "un segnaposto è ancora vuoto",
    "alcuni segnaposto sono ancora vuoti"
  ],
  "i18n.dialog.unchangedPlaceholders.message": [
    "Una variabile non è stata cambiata.",
    "Alcune variabili non sono state cambiate."
  ],
  "i18n.dialog.unchangedPlaceholders.misc.message": [
    "Clicca sul segnaposto della foto o del testo per cambiare il Suo collage",
    "Clicca sui segnaposti della foto o del testo per cambiare i Suo collage"
  ],
  "i18n.dialog.unchangedPlaceholders.misc.title": [
    "Un segnaposto non è stato modificato",
    "Alcuni segnaposti non sono stati modificati"
  ],
  "i18n.dialog.unchangedPlaceholders.text.message": [
    "Clicca sul segnaposto del testo per cambiare il tuo testo",
    "Clicca sui segnaposto del testo per cambiare i tuoi testi"
  ],
  "i18n.dialog.unchangedPlaceholders.text.title": [
    "Un segnaposto del testo non è stato cambiato",
    "Alcuni segnaposto del testo non sono stati cambiati "
  ],
  "i18n.dialog.unchangedPlaceholders.title": "variabili non modificate",
  "i18n.error.additionalInfoItemsError.message": "Errore di caricamento del livello di informazione",
  "i18n.error.additionalInfoItemsError.title": "Errore di caricamento",
  "i18n.error.deprecatedBrowserError.message": "Il browser che stai utilizzando non è più supportato. Ti preghiamo di aggiornarlo a una versione più recente.",
  "i18n.error.deprecatedBrowserError.title": " ",
  "i18n.error.designerExpiredError.message": "Hai interotto la realizzazione del tuo ordine per un periodo di tempo troppo lungo. Non è possibile continuare. Ti preghiamo di avviare nuovamente la procedura.",
  "i18n.error.designerExpiredError.title": "Progettazione terminata",
  "i18n.error.fontLoadingError.message": "Un carattere non è stato caricato",
  "i18n.error.fontLoadingError.title": "Errore di caricamento ",
  "i18n.error.imageLoadingError.message": "Una foto potrebbe non essere stata caricata.\nE’ stata rimossa dall’area di disegno e dalla galleria.",
  "i18n.error.imageLoadingError.title": "Errore nel download",
  "i18n.error.imageProvisionError.message": "Una o più foto potrebbero non essere state processate. Il formato file potrebbe non essere supportato.",
  "i18n.error.imageProvisionError.title": "Una foto potrebbe non essere stata processata",
  "i18n.error.imageSelectionError.message": "File \"{{reference1}}\" potrebbe non essere stato processato.",
  "i18n.error.imageSelectionError.title": "Errore durante il caricamento della foto",
  "i18n.error.imageSizeLimitExceededError.message": "L’immagine che hai caricato è troppo grande.\nTi preghiamo di ridurla a meno di 180 megapixel e di ricaricarla nuovamente.",
  "i18n.error.imageSizeLimitExceededError.title": "Errore durante il caricamento della foto",
  "i18n.error.imageUploadError.message": "Si è verificato un errore durante la connessione ad internet.\nSi prega di riprovare più tardi.",
  "i18n.error.imageUploadError.title": "Errore durante il caricamento della foto ",
  "i18n.error.inlineSVGLoadingError.message": "La tolleranza della cornice  \"{{reference1}}\" non può essere caricata.",
  "i18n.error.inlineSVGLoadingError.title": "Errore nel download ",
  "i18n.error.invalidCharConfigError.message": "Questo carattere non è utilizzabile, si prega di sceglierne un altro.",
  "i18n.error.invalidCharConfigError.title": "Carattere non è utilizzabile",
  "i18n.error.malformedProductError.message": "Uno o più prodotti non possono essere trasferiti sul server, probabilmente il prodotto non è più disponibile o la progettazione ha richiesto troppo tempo. Siamo spiacenti. Ti preghiamo di iniziare nuovamente la realizzazione del prodotto.",
  "i18n.error.malformedProductError.title": "Errore di caricamento",
  "i18n.error.notInStockError.message": "Purtroppo il prodotto selezionato non è al momento disponibile.\nIl nostro logo in alto a sinistra ti porterà alla pagina iniziale. Da qui è possibile selezionare un altro prodotto.",
  "i18n.error.notInStockError.title": " ",
  "i18n.error.offlineNotice": "Sembra che la tua connessione ad internet si sia interrotta. Potrai continuare a progettare il tuo prodotto non appena la connessione sarà ristabilita.",
  "i18n.error.templateLoadingError.message": "Il modello \"{{ error.reference[0] }}\" non può essere caricato.\nTi preghiamo di riprovare più tardi.",
  "i18n.error.templateLoadingError.title": "Errore nel download ",
  "i18n.error.transformationError.message": "La trasformazione non può essere processata",
  "i18n.error.transformationError.title": "Errore di trasformazione ",
  "i18n.error.traudlLoadingError.message": "Prova di nuovo oppure utilizza un'altra imagine.",
  "i18n.error.traudlLoadingError.title": "Non è stato possibile applicare un filtro AI.",
  "i18n.error.unsupportedMediaTypeError.message": "\"{{reference1}}\" hai un formato file non supportato.",
  "i18n.error.unsupportedMediaTypeError.title": "Errore durante il caricamento della foto ",
  "i18n.error.uploadProductError.message": "Uno o più prodotti non possono essere trasferiti al server.\nTi preghiamo di riprovare più tardi.",
  "i18n.error.uploadProductError.title": "Errore nel trasferimento",
  "i18n.error.zoomModeError.message": "Il testo della tua precedente configurazione non può essere utilizzato. Ti preghiamo di inserire un nuovo testo.",
  "i18n.error.zoomModeError.title": "Testo non adottato",
  "i18n.gallery.uploadPhotos.info": "Clicca su \"carica foto\"",
  "i18n.gallery.uploadProgress": [
    "Caricamento foto ...",
    "Foto caricate: {{current}} di {{total}}"
  ],
  "i18n.price.price": "Prezzo",
  "i18n.price.reduction": "Risparmia",
  "i18n.price.total": "Prezzo totale",
  "i18n.priceDisplay.times": [
    "{{value}} pezzo a {{pricePerUnit}} cadauno",
    "{{value}} pezzi a {{pricePerUnit}} cadauno"
  ],
  "i18n.progress.stepAdditionalProducts": "Accessori (opzionali)",
  "i18n.progressOverlay.message.lines.one": "Grazie per la tua creazione.",
  "i18n.progressOverlay.message.lines.two": "Stiamo preparando il tuo prodotto...",
  "i18n.template.insertText": "Inserisci il testo qui",
  "i18n.toolbox.gallery.title": "Seleziona foto",
  "i18n.toolbox.image.title": "Modifica foto",
  "i18n.toolbox.layout.template.suitableFor": [
    "1 foto",
    "{{value}} foto"
  ],
  "i18n.toolbox.layout.title": "Modifica Layout",
  "i18n.toolbox.layout.triggerText": "Layout",
  "i18n.toolbox.preview.title": "Anteprima 3D",
  "i18n.toolbox.productChooser.title": "Cambia prodotto",
  "i18n.toolbox.productChooser.triggerText": "Prodotto",
  "i18n.toolbox.text.title": "Modifica il testo"
};


export class LocaleItIT {
  public getPlural(n: number): number
  {
    const pluralForm = (n != 1);
    if (typeof(pluralForm) === 'boolean') {
      return pluralForm ? 1 : 0;
    }
    return pluralForm;
  }
  public getTranslations(): any
  {
    return TRANSLATIONS;
  }
}
/* tslint:enable */
